<template>
  <v-container fluid>
    <ApiDataForm
      data-api="settings"
      title="Application Settings"
      form-mode="edit"
      can-save="true"
    />
  </v-container>
</template>

<script>
import ApiDataForm from "../ui/shared/ApiDataForm.vue";

export default {
  name: "Settings",

  components: { ApiDataForm },
};
</script>
